import { useEffect, useState } from 'react'
import { breakpoints } from './config';

export const useBreakpoints = () => {

    const [size, setSize] = useState({
        x: window.innerWidth,
        y: window.innerHeight
    });

    const [breakpoint, setBreakpoint] = useState("lg");

    
    const updateSize = () => setSize({ x: window.innerWidth, y: window.innerHeight });

    const up = (breakpoint) => size.x > breakpoints[breakpoint];
    const down = (breakpoint) => size.x < breakpoints[breakpoint];

    useEffect(() => (window.onresize = updateSize), []);

    useEffect(() => {
        const x = size.x;
        if (x >= breakpoints.xs && x < breakpoints.sm) {
            setBreakpoint("xs");
        } else if (x >= breakpoints.sm && x < breakpoints.md) {
            setBreakpoint("sm");
        } else if (x >= breakpoints.md && x < breakpoints.lg) {
            setBreakpoint("md");
        } else if (x >= breakpoints.lg && x < breakpoints.xl) {
            setBreakpoint("lg");
        } else if (x >= breakpoints.xl && x < breakpoints.xxl) {
            setBreakpoint("xl");
        } else if (x >= breakpoints.xxl) {
            setBreakpoint("xxl");
        }
    }, [size.x]);

    // useEffect(() => {
    //     console.log(breakpoint);
    // }, [breakpoint]);
    
    return { breakpoint, up, down };
}